import { render, staticRenderFns } from "./GoodsReceiveDetail.vue?vue&type=template&id=30d890d3&scoped=true"
import script from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
export * from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceiveDetail.vue?vue&type=style&index=0&id=30d890d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d890d3",
  null
  
)

export default component.exports